import React, {Component} from "react";
import SweetAlert from 'react-bootstrap-sweetalert';
import {I18n} from "../../../../I18n/components/loan";
import {SUPER_ADMIN, USER_ROLES} from "../../../../helpers/constants";
import {Alert, Card, CardBody, CardTitle} from "reactstrap";
import {closeAlert} from "../../../../actions/commonsActions";
import {goBack, push} from "connected-react-router";
import {connect} from "react-redux";
import {fetchLoanAvailableProps} from "../../../../actions/loan/loanAvailablePropertyActions";
import LoanBankPropertyList from "./LoanBankPropertyList";
import LoanRetailerPropertyList from "./LoanRetailerPropertyList";
import {
    saveSingleLoanRetailerProperty,
    updateSingleLoanRetailerProperty
} from "../../../../actions/loan/loanRetailerPropertyAction";
import {
    saveSingleLoanBankProperty,
    updateSingleLoanBankProperty
} from "../../../../actions/loan/loanBankPropertyAction";
import swal from "sweetalert";
import {isLoansPermission} from "../../../../helpers/companyService";

class LoanAvailableProps extends Component {

    constructor(props) {
        super(props);
        this.state = {
            retailerId: null,
            bankIntegration: null,
            activeBankProperty: null,
            activeRetailerProperty: null,
            updateInProgress: false,
        };
    }

    componentDidMount() {
        (async () => {
            const {match, location, company, authority, lang} = this.props;

            if (!isLoansPermission(company, authority)) {
                await swal(I18n[lang].contactUsToAccessThis, '', 'error')
                    .then(() => this.props.goBack())
                return;
            }

            const bankIntegration = match && match.params ? match.params.bankIntegration : null;

            await this.setState({
                bankIntegration: bankIntegration,
                retailerId: authority === SUPER_ADMIN ? location.state.retailerId : company.id,
            });

            await this.fetchData();
        })();
    }

    fetchData = async () => {
        const {retailerId, bankIntegration} = this.state;
        await this.props.fetchAvailableProps({
            integration: bankIntegration,
            retailerId
        });
    };

    openBankPropertyAlert = property => this.setState({activeBankProperty: property});

    openRetailerPropertyAlert = property => this.setState({activeRetailerProperty: property});

    closeBankPropertyAlert = () => this.setState({activeBankProperty: null});

    closeRetailerPropertyAlert = () => this.setState({activeRetailerProperty: null});

    onConfirmBankPropertyAlert = async value => {
        const {lang} = this.props;
        const {activeBankProperty} = this.state;

        activeBankProperty.value = value;
        this.setState({updateInProgress: true});

        const promise = activeBankProperty.id
            ? this.props.updateBankProperty(activeBankProperty)
            : this.props.saveBankProperty(activeBankProperty);
        await promise.then(async () => {
            this.closeBankPropertyAlert();
            await this.fetchData();
        }).catch(async error => {
            let message = error && error.message ? error.message : JSON.stringify(error);
            await swal(I18n[lang].error, message, "error");
        })

        this.setState({updateInProgress: false});
    };

    onConfirmRetailerPropertyAlert = async value => {
        const {lang} = this.props;
        const {activeRetailerProperty} = this.state;

        activeRetailerProperty.defaultValue = value;
        this.setState({updateInProgress: true});

        const promise = activeRetailerProperty.id
            ? this.props.updateRetailerProperty(activeRetailerProperty)
            : this.props.saveRetailerProperty(activeRetailerProperty);
        await promise.then(async () => {
            this.closeRetailerPropertyAlert();
            await this.fetchData();
        }).catch(async error => {
            let message = error && error.message ? error.message : JSON.stringify(error);
            await swal(I18n[lang].error, message, "error");
        })

        this.setState({updateInProgress: false});
    };

    renderConfirmAlertBtn = () => (
        <div>
            {this.state.updateInProgress ? <i className="fa fa-spinner fa-spin mr-2"/> : ''}
            {I18n[this.props.lang].confirm}
        </div>
    );

    render() {
        const {
            lang,
            loading,
            loanAvailableProps,
        } = this.props;
        const {bankIntegration, activeBankProperty, activeRetailerProperty} = this.state;

        return (
            <div>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed" : ''}
                </Alert>
                {
                    activeBankProperty && <SweetAlert
                        input
                        showCancel
                        required={false}
                        confirmBtnText={this.renderConfirmAlertBtn()}
                        cancelBtnText={I18n[lang].cancel}
                        title={activeBankProperty.name}
                        defaultValue={activeBankProperty.value}
                        onConfirm={response => this.onConfirmBankPropertyAlert(response)}
                        onCancel={this.closeBankPropertyAlert}
                    />
                }
                {
                    activeRetailerProperty && <SweetAlert
                        input
                        showCancel
                        required={false}
                        confirmBtnText={this.renderConfirmAlertBtn()}
                        cancelBtnText={I18n[lang].cancel}
                        title={activeRetailerProperty.name}
                        defaultValue={activeRetailerProperty.defaultValue}
                        onConfirm={response => this.onConfirmRetailerPropertyAlert(response)}
                        onCancel={this.closeRetailerPropertyAlert}
                    />
                }

                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-settings mr-2"/>
                            {I18n[lang].loans + " / " + I18n[lang].settings + " / " + bankIntegration}
                        </div>
                    </CardTitle>

                    <CardBody>
                        {
                            loading ? <div className="loading">Loading...</div> :
                                <div>
                                    <LoanBankPropertyList
                                        lang={lang}
                                        bankProps={loanAvailableProps.bankProps}
                                        onEditProperty={this.openBankPropertyAlert}
                                    />
                                    <div className="m-2"/>
                                    <LoanRetailerPropertyList
                                        lang={lang}
                                        retailerProps={loanAvailableProps.retailerProps}
                                        onEditProperty={this.openRetailerPropertyAlert}
                                    />
                                </div>
                        }
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchAvailableProps: query => dispatch(fetchLoanAvailableProps(query)),
        saveBankProperty: bankProperty => dispatch(saveSingleLoanBankProperty(bankProperty)),
        updateBankProperty: bankProperty => dispatch(updateSingleLoanBankProperty(bankProperty)),
        saveRetailerProperty: retailerProperty => dispatch(saveSingleLoanRetailerProperty(retailerProperty)),
        updateRetailerProperty: retailerProperty => dispatch(updateSingleLoanRetailerProperty(retailerProperty)),
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: url => dispatch(push(url)),
        goBack: () => dispatch(goBack()),
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    loanAvailableProps: state.loanAvailableProps.loanAvailableProps,
    loading: state.loanAvailableProps.loading,
    authority: state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(LoanAvailableProps);


// WEBPACK FOOTER //
// ./src/components/Loan/Property/Available/LoanAvailableProps.js